window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.playerGameDetailsRepo = function () {

    var urlGames = 'api/playergamedetails';

    var get = function (providerId, sessionId, page) {
        return fetch(urlGames +
                casino.repos.base.serializeGetParams({
                    provider: providerId,
                    sessionId: sessionId,
                    page: page
                }), {
                    credentials: repos.base.credentials,
                    headers: repos.base.headers()
                })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }

}();